import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";

import { colors } from "../../../theme/palette";
import { DashboardV2Icon } from "../../../assets/icons/MUI/DashboardIcons";
import { useQueryAudienceData } from "../../../api/queries/dashboard/useQueryHumanResources";

import Audience from "./Audience";
import AudienceLocation from "./AudienceLocation";

const HumanResourcesV2 = () => {
  const { t } = useTranslation();
  const [location, setLocation] = useState<"CITY" | "COUNTRY">("CITY");

  const { audienceByLocationData, isAudienceByLocationDataLoading, followersPerAgeData, isFollowersPerAgeDataLoading } =
    useQueryAudienceData(location);

  return (
    <Box sx={styles.container}>
      <Typography sx={styles.title}>
        <DashboardV2Icon />
        {t("pages.dashboard.humanResources")}
      </Typography>
      <Typography sx={styles.description}>{t("pages.dashboard.valuesBasedTotalFollowers")}</Typography>
      <Box sx={styles.audienceContainer}>
        <Audience dataset={followersPerAgeData?.data} isLoading={isFollowersPerAgeDataLoading} />
        <AudienceLocation
          data={audienceByLocationData?.data?.result || []}
          location={location}
          setLocation={setLocation}
          isLoading={isAudienceByLocationDataLoading}
        />
      </Box>
    </Box>
  );
};

export default HumanResourcesV2;

const styles = {
  container: {
    borderRadius: "8px",
    border: "1px solid #EAECF0",
    background: colors.White,
    width: "100%",
    minHeight: "495px",
    padding: "26px 20px",
  },
  title: {
    display: "flex",
    alignItems: "center",
    columnGap: "10px",
    color: colors.Black100,
    fontFamily: "Montserrat",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "normal",
    marginBottom: "8px",
  },
  description: {
    color: colors.Dark600,
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
    marginBottom: "37px",
  },
  audienceContainer: {
    display: "grid",
    gridTemplateColumns: {
      xs: "repeat(1, 1fr)",
      md: "repeat(2, 1fr)",
    },
    gap: { xs: "30px", md: "10px" },
  },
};
